module.exports = __webpack_public_path__ + "img/desechablesnunez.fc205fe9.png";